import ZTable, { IColumnType, ITableRef } from '@/components/ZTable';
import { ModalWidth, formatDisplayFullDate } from '@/config';
import { Button, Modal, List } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { InfoOutlined } from '@ant-design/icons';
import { BookingHistoryDto } from '@/__generated';

type Props = {
  bookingId?: string;
  tripId?: string;
  onClose: () => void;
};

export default function BookingChangeModal({ bookingId, tripId, onClose }: Props) {
  const { t } = useTranslation();
  const columns: IColumnType<BookingHistoryDto>[] = React.useMemo(() => {
    return [
      {
        title: t('bookingPage_Comments'),
        dataIndex: 'comments',
        ellipsis: true,
      },
      {
        title: t('bookingPage_ChangeDate'),
        dataIndex: 'changeDate',
        render: (value: any) => formatDisplayFullDate(value),
        width: 170,
      },

      {
        width: 150,
        align: 'center',
        title: t('bookingPage_ChangeValues'),
        dataIndex: 'changeValues',
        render(changeValues: any, value: BookingHistoryDto) {
          return (
            <Button
              size="small"
              type="primary"
              shape="circle"
              icon={<InfoOutlined />}
              onClick={() => {
                Modal.info({
                  title: t('bookingPage_ChangeValues'),
                  content: (
                    <List
                      size="small"
                      bordered
                      dataSource={changeValues}
                      renderItem={(item: any) => {
                        let v = ` ${item.oldValue} -> ${item.newValue}`;

                        return <List.Item>{`[${item.propertyName}] ${v}`}</List.Item>;
                      }}
                    />
                  ),
                  width: 700,
                });
              }}
            ></Button>
          );
        },
      },
    ] as IColumnType<BookingHistoryDto>[];
  }, []);
  return (
    <Modal
      width={ModalWidth.extraLarge}
      title={bookingId ? t('bookingPage_BookingHistory') : t('bookingPage_TripHistory')}
      onOk={onClose}
      okText={t('Close')}
      cancelButtonProps={{ style: { display: 'none' } }}
      open={true}
      onCancel={onClose}
    >
      {bookingId ? (
        <ZTable<any>
          columns={columns}
          primaryKey="id"
          defaultFilter={{ bookingId: bookingId }}
          url="/bookings/booking-histories/get-booking-histories"
          bordered
          order_by="changeDate"
          order_by_asc={false}
          allowEdit={false}
          allowDelete={false}
        />
      ) : null}
      {tripId ? (
        <ZTable<any>
          columns={columns}
          primaryKey="id"
          defaultFilter={{ EntityId: tripId }}
          url="/bookings/booking-histories/get-booking-histories"
          bordered
          order_by="changeDate"
          order_by_asc={false}
          allowEdit={false}
          allowDelete={false}
        />
      ) : null}
    </Modal>
  );
}
